export const REASON_FOR_SEARCH = [
  { value: 'CONSENT', label: 'Consent' },
  { value: 'INVENTORY', label: 'Inventory' },
  {
    value: 'CONTRABAND_EVIDENCE_IN_PLAIN_VIEW',
    label: 'Contraband / Evidence in Plain View',
  },
  { value: 'PROBABLE_CAUSE', label: 'Probable Cause' },
  { value: 'INCIDENT_TO_ARREST', label: 'Incident to Arrest' },
  { value: 'NOT_APPLICABLE', label: 'N/A' },
] as const;
